/**
 * Organization Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Group } from './group';


export interface GroupDirectoryModel { 
    groupDirectoryId?: number;
    groupId: number;
    organizationDirectoryId: number;
    directoryName?: string | null;
    uniqueID?: string | null;
    modifiedDate?: string;
    modifiedBy?: string | null;
    organizationId?: number;
    group?: Group;
}

